const initialState = {};

const Reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "SAVE_TimesheetWeek":
      return { ...state, Week: payload };
    case "CLEAR":
      return initialState;
    default:
      return state;
  }
};

export default Reducer;
